import { useState } from 'react'
import axios, { CancelTokenSource } from 'axios'
import { AuthorInterface } from '../../../../core/interface/author.interface'
import getAuthorSearchService from '../../../../core/api/services/bookmetrie/get-author-search.service'

interface UseAuthorAutoCompletionState {
  isLoadingGetAuthorsByQuery: boolean
  getAuthorsByQuerySuccess: boolean
  getAuthorsByQueryError: boolean
  authors: AuthorInterface[]
}

interface UseAuthorAutoCompletionHook {
  state: UseAuthorAutoCompletionState
  actions: {
    getAuthorsByQuery(query: string): void
    setAuthors(authors: AuthorInterface[]): void
    resetAuthors(): void
  }
}

const useAuthorAutoCompletionHook = (): UseAuthorAutoCompletionHook => {
  const [isLoadingGetAuthorsByQuery, setIsLoadingGetAuthorsByQuery] =
    useState<boolean>(false)
  const [getAuthorsByQuerySuccess, setGetAuthorsByQuerySuccess] =
    useState<boolean>(false)
  const [getAuthorsByQueryError, setGetAuthorsByQueryError] =
    useState<boolean>(false)

  const [cancelTokenGetAuthorSearch, setCancelTokenGetAuthorSearch] =
    useState<CancelTokenSource | null>(null)
  const [authors, setAuthors] = useState<AuthorInterface[]>([])

  const getAuthorsByQuery = (query: string): void => {
    if (cancelTokenGetAuthorSearch) {
      cancelTokenGetAuthorSearch.cancel()
    }
    const cancelToken = axios.CancelToken.source()
    setCancelTokenGetAuthorSearch(cancelToken)
    setIsLoadingGetAuthorsByQuery(true)
    setGetAuthorsByQuerySuccess(false)
    setGetAuthorsByQueryError(false)
    getAuthorSearchService(query, cancelToken?.token)
      .then((response) => {
        setGetAuthorsByQuerySuccess(true)
        const { data } = response
        setAuthors(data)
      })
      .catch(() => {
        setGetAuthorsByQueryError(true)
        setAuthors([])
      })
      .finally(() => {
        setIsLoadingGetAuthorsByQuery(false)
        setCancelTokenGetAuthorSearch(null)
      })
  }

  const resetAuthors = () => {
    setIsLoadingGetAuthorsByQuery(false)
    setGetAuthorsByQuerySuccess(false)
    setIsLoadingGetAuthorsByQuery(false)
    setAuthors([])
  }
  return {
    state: {
      isLoadingGetAuthorsByQuery,
      getAuthorsByQuerySuccess,
      getAuthorsByQueryError,
      authors,
    },
    actions: {
      getAuthorsByQuery,
      setAuthors,
      resetAuthors,
    },
  }
}

export default useAuthorAutoCompletionHook
